<script>
import api from "@/helpers/api-rest/api.js";
import store from "@/state/store";
import format from "date-fns/format";
import AccessionCompanyModal from "@/components/modals/accession-company-modal.vue";
import AccessionGeneralModal from "@/components/modals/accession-general-modal.vue";
import qs from "qs";

export default {
  props: {
    essayId: { type: [Number, String] },
    centerId: { type: Number },
  },
  components: {
    AccessionCompanyModal,
    AccessionGeneralModal,
  },
  data() {
    return {
      tableData: [],
      title: "Usuarios",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "created_at",
          sortable: false,
          label: "Fecha de creación",
          formatter: (value) => {
            return format(new Date(value), "dd/MM/yyyy");
          },
        },
        { key: "name", sortable: false, label: "Empresa" },
        { key: "cif", sortable: false, label: "CIF" },
        { key: "document", sortable: false, label: this.renderDocumentLabel() },
        { key: "status", sortable: false, label: "Estado" },
        { key: "generate_anexoV", sortable: false, label: "Documento de Adhesión" },
        {
          key: "action",
          tdClass: "custom-table-action",
          sortable: false,
          label: "",
        },
      ],
      editMode: false,
      accessionCompanyModalId: "ModalAccessionCompany",
      accessionGeneralModalId: "ModalAccessionGeneralCompany",
      accesionCompanyEdit: undefined,
      accesionGeneralEdit: undefined,
      dataEssay: {},
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    loadDataEssay() {
      const apiEndpoint = `/api/v1/essays/${this.essayId}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          // Be defensive: response or response.data may be undefined when the API fails
          const data =
            response && response.data && response.data.data
              ? response.data.data
              : null;
          if (data) {
            this.dataEssay = data;
          } else {
            // Keep a safe default so template bindings don't throw
            this.dataEssay = {};
            console.warn(
              `loadDataEssay: unexpected response structure`,
              response
            );
          }
        })
        .catch((error) => {
          // On network / CORS / server errors assign a safe default and log
          this.dataEssay = {};
          console.error("Error loading data (loadDataEssay):", error);
        });
    },
    renderDocumentLabel() {
      return `<span>
          Documento <i v-b-tooltip.hover title="Anexo VI" class="far fa-question-circle font-size-12 ml-2"></i>
        </span>`;
    },
    showElement(
      roleId = [],
      show = true,
      showRechazado = true,
      showRenuncia = true
    ) {
      const role = store.getters["auth/role"];
      if (roleId.includes(role.id) && show && showRechazado && showRenuncia) {
        return true;
      }
      return false;
    },
    loadDataFromApi() {
      const apiEndpoint = `/api/v1/accession-company-partners?essay_id=${this.essayId}`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          const data =
            response && response.data && response.data.data
              ? response.data.data
              : null;
          if (Array.isArray(data)) {
            this.tableData = data;
          } else {
            // ensure tableData is always an array to avoid template errors
            this.tableData = [];
            console.warn(
              `loadDataFromApi: unexpected response structure`,
              response
            );
          }
        })
        .catch((error) => {
          this.tableData = [];
          console.error("Error loading data (loadDataFromApi):", error);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadFile(fileName, folderID) {
      const params = {
        fileName: fileName,
        folderID: folderID,
      };

      const queryString = qs.stringify(params);
      const baseUrl = process.env.VUE_APP_API_HOST;
      const url = `${baseUrl}/download-drive?${queryString}`;
      window.open(url, "_blank");
    },
    success() {
      this.loadDataFromApi();
    },
    editAccessionCompany(accesion_company) {
      this.accesionCompanyEdit = accesion_company;
      this.$bvModal.show(this.accessionCompanyModalId);
    },
    addAccessionCompany() {
      this.accesionCompanyEdit = { id: null, document_name: null };
      this.$bvModal.show(this.accessionCompanyModalId);
    },
    editGenerateAnexoV(accesion_general) {
      accesion_general.typeAccession = "company";
      this.accesionGeneralEdit = accesion_general;
      this.$bvModal.show(this.accessionGeneralModalId);
    },
    addGenerateAnexoV(accesion_general) {
      const currentDate = new Date().toISOString().slice(0, 10);
      this.accesionGeneralEdit = {
        id: null,
        document_name: null,
        typeAccession: "company",
        accession_general_generate: {
          accession_company_id: accesion_general.id,
          reason: "",
          accession_general_activities: [
            {
              id: "",
              accession_general_id: this.accesionGeneralEdit?.id,
              contingency_plan: "",
              cost: "",
              responsables: "",
              risks: "",
              description: "",
              init_date: currentDate,
              end_date: currentDate,
            },
          ],
        },
      };
      this.$bvModal.show(this.accessionGeneralModalId);
    },
  },
  mounted() {
    this.loadDataFromApi();
    this.loadDataEssay();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
  },
};
</script>

<template>
  <div>
    <AccessionCompanyModal
      :id="accessionCompanyModalId"
      :accesion_company="accesionCompanyEdit"
      :essayId="essayId"
      :centerId="centerId"
      @success="success"
    />
    <AccessionGeneralModal
      :id="accessionGeneralModalId"
      :accession_general="accesionGeneralEdit"
      :essayId="essayId"
      @success="success"
    />
    <button
      v-if="
        showElement(
          [3],
          dataEssay?.essay_status_id != 7,
          dataEssay?.essay_status_id != 4,
          dataEssay?.essay_status_id != 6
        )
      "
      @click="addAccessionCompany()"
      class="btn btn-success mb-4"
    >
      <i class="fa fa-plus"></i> Añadir empresa
    </button>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title">Lista de adhesiones de empresas</h4>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
                ref="userTable"
              >
                <template v-slot:cell(status)="row">
                  <div>
                    <div>
                      <b-badge
                        pill
                        :variant="
                          row.item.status === 'pendiente'
                            ? 'info'
                            : row.item.status === 'rechazada'
                            ? 'danger'
                            : 'success'
                        "
                      >
                        {{
                          row.item.status === "pendiente"
                            ? "Pendiente"
                            : row.item.status === "rechazada"
                            ? "Rechazada"
                            : "Aceptada"
                        }}
                      </b-badge>
                    </div>
                  </div>
                </template>
                <template v-slot:head(document)="data">
                  <div v-html="data.label"></div>
                </template>
                <template v-slot:head(generate_anexoV)>
                  <div>
                    Documento de Adhesión
                    <i
                      v-b-tooltip.hover
                      title="Definir acciones requeridas para la adhesión"
                      class="far fa-question-circle font-size-12 ml-2"
                    ></i>
                  </div>
                </template>
                <template v-slot:cell(document)="row">
                  <div v-if="row.item.document_path">
                    <a
                      href="javascript:void(0);"
                      class="mr-3 text-secondary"
                      @click.prevent="
                        downloadFile(
                          row.item.document_name,
                          row.item.essay.folder_documents_id
                        )
                      "
                    >
                      <i class="mdi mdi-file-download-outline font-size-18"></i>
                    </a>
                  </div>
                </template>
                <template v-slot:cell(generate_anexoV)="row">
                  <div v-if="row.item.accession_general_generate">
                    <b-button
                      pill
                      size="sm"
                      class="w-75"
                      @click="editGenerateAnexoV(row.item)"
                      ><i class="mdi mdi-eye-outline font-size-14"></i>
                      Ver</b-button
                    >
                  </div>
                  <div v-else>
                    <b-button
                      pill
                      size="sm"
                      class="w-75"
                      @click="addGenerateAnexoV(row.item)"
                      title="Definir acciones requeridas para la adhesión"
                      ><i class="fa fa-plus"></i> Generar</b-button
                    >
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="mr-3 text-secondary"
                      :title="[4, 6, 7].includes(dataEssay?.essay_status_id) ? 'Ver' : 'Edit'"
                      @click="editAccessionCompany(row.item)"
                    >
                      <i
                        :class="
                          [4, 6, 7].includes(dataEssay?.essay_status_id)
                            ? 'mdi mdi-eye-outline font-size-18'
                            : 'mdi mdi-square-edit-outline font-size-18'
                        "
                      ></i>
                    </a>
                  </div>
                </template>
                <template v-slot:empty>
                  <div class="text-center">No hay registros</div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
